import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { ConfirmDialog } from '../PrototypeShared';

export default function RegisterScreen() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmModal, setConfirmModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
  };

  const handleConfirm = () => {
    setConfirmModal(false);
    navigate('/prototype/pending');
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Register</Typography>
        <Typography color="text.secondary" paragraph>Prototype: submit to see confirmation, then Pending Approval.</Typography>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="Name" value={name} onChange={(e) => setName(e.target.value)} margin="normal" />
          <TextField fullWidth label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} margin="normal" />
          <TextField fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>Register</Button>
        </form>
        <Button component={Link} to="/prototype/login" size="small" sx={{ mt: 2 }}>Back to Login</Button>
      </Paper>
      <ConfirmDialog open={confirmModal} title="Registration submitted" message="Your account is pending approval. You will be redirected to the pending page." onConfirm={handleConfirm} onCancel={() => setConfirmModal(false)} confirmLabel="OK" />
    </Box>
  );
}
